@if (type() === 'default') {
  <div class="border-4 border-dashed rounded-full animate-spin mx-auto" [class]="sizeClasses() + ' ' + color()"></div>
} @else {
  <div class="flex items-end justify-center gap-1.5" role="status" aria-label="Loading">
    <span class="dot-wave rounded-full bg-primary opacity-90" [class]="dotSizeClasses()"></span>
    <span class="dot-wave rounded-full bg-secondary opacity-80" [class]="dotSizeClasses()"></span>
    <span class="dot-wave rounded-full bg-primary opacity-70" [class]="dotSizeClasses()"></span>
    <span class="dot-wave rounded-full bg-secondary opacity-60" [class]="dotSizeClasses()"></span>
    <span class="dot-wave rounded-full bg-primary opacity-50" [class]="dotSizeClasses()"></span>
  </div>
}
